module.exports = __webpack_public_path__ + "static/media/cuteCut-02.cde09961.png";